import { render, staticRenderFns } from "./OrdonnanceListe.vue?vue&type=template&id=7859aff4&"
import script from "./OrdonnanceListe.vue?vue&type=script&lang=js&"
export * from "./OrdonnanceListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports